<template>
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.14453 2.35815H19.8565" stroke="currentColor" stroke-width="3.28" stroke-linecap="round" />
    <path d="M2.14453 9.00024H19.8565" stroke="currentColor" stroke-width="3.28" stroke-linecap="round" />
    <path d="M2.14453 15.6421H19.8565" stroke="currentColor" stroke-width="3.28" stroke-linecap="round" />
  </svg>
</template>
